import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Wheat, Eye, EyeOff } from 'lucide-react';

export default function LoginDashboard() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.role === 'cliente') {
        navigate('/pedidos');
      } else {
        navigate('/admin/dashboard');
      }
    } catch (err) {
      setError(err.userMessage || 'E-mail ou senha incorretos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center px-4" data-testid="dashboard-login-page">
      <div className="w-full max-w-sm animate-slide-in">
        <div className="text-center mb-8">
          <img src="/logo-fatima.jpg" alt="Fátima Guterres" className="w-48 h-auto rounded-2xl mx-auto mb-3 shadow-lg object-cover" />
          <p className="text-brand-text-muted text-sm font-body mt-1">Painel Administrativo</p>
        </div>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-brand-border">
          <h2 className="font-dashboard font-bold text-brand-text mb-5">Entrar no Dashboard</h2>
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl px-4 py-3 mb-4" data-testid="login-error">{error}</div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-brand-text-muted mb-1.5 font-body">E-mail</label>
              <input type="email" className="w-full rounded-lg border border-brand-border px-3 py-2.5 text-sm font-body focus:outline-none focus:ring-2 focus:ring-brand-accent-mid focus:border-brand-primary bg-white" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="seu@email.com" required data-testid="login-email" />
            </div>
            <div>
              <label className="block text-sm font-medium text-brand-text-muted mb-1.5 font-body">Senha</label>
              <div className="relative">
                <input type={showPwd ? 'text' : 'password'} className="w-full rounded-lg border border-brand-border px-3 py-2.5 text-sm font-body focus:outline-none focus:ring-2 focus:ring-brand-accent-mid focus:border-brand-primary bg-white pr-10" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required data-testid="login-password" />
                <button type="button" onClick={() => setShowPwd(!showPwd)} className="absolute right-3 top-1/2 -translate-y-1/2 text-brand-text-muted">
                  {showPwd ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <Link to="/admin/recuperar-senha" className="text-xs text-brand-primary font-body block text-right">Esqueci minha senha</Link>
            <button type="submit" disabled={loading} className="w-full py-2.5 rounded-lg btn-primary font-dashboard font-semibold text-sm disabled:opacity-60" data-testid="login-submit">
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-brand-text-muted mt-4 font-body">
          Acesso de cliente?{' '}
          <Link to="/login" className="text-brand-primary font-medium">App Mobile</Link>
        </p>
      </div>
    </div>
  );
}
